import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import Alert from '../../helpers/Alert';


import { activeUser } from '../../services/UserService';


export default function ConfirmUser() {
  const location = useLocation();
  let history = useNavigate();

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const email = params.get('e') || '';
      const token = params.get('t') || '';

      activeUser(email, token).then(res => {
        Alert(true, "Sua conta foi ativada!")
        history('/login')
      }).catch(err => {
        Alert(false, "Não foi possivel ativar a conta!")
        history('/login')
      })
    } catch (error) {
      Alert(false, "Ocorreu um erro ao ativar a conta!")
      console.log(error)
      history('/login')
    }
  }, [])


  return (
    <div>
    </div>
  )
}
